import User from '@models/User.js';

export default {
    // Esto permite acceder a este módulo usando namespaces
    namespaced: true,
    state: {
        modalAuth: 1,
        user: new User(),
        emailsCommon: [
            "gmail.com",
            "yahoo.com",
            "hotmail.com",
            "outlook.com",
            "live.com",
            "icloud.com",
            "zoho.com"
        ],
    },
    mutations: {
        SET_MODAL_AUTH(state, value) {
            state.modalAuth = value;
        },
        SET_USER(state, value) {
            state.user = new User(value);
        }
    },
    actions: {
        setModalAuth({ commit }, value) {
            commit("SET_MODAL_AUTH", value);
        },
        setUser({ commit }, value) {
            commit("SET_USER", value);
        }
    },
    getters: {
        getModalAuth: (state) => state.modalAuth,
        getUser: (state) => state.user,
        getEmailsCommon: (state) => state.emailsCommon
    },
};
